import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
});


const CenterMap = ({ selected }) => {
  const map = useMap();

  useEffect(() => {
    if (selected?.latitude && selected?.longitude) {
      map.setView([selected.latitude, selected.longitude], 15);
    }
  }, [selected, map]);

  return null;
};

const Map = ({ selected }) => {
  const center = selected ? [selected.latitude, selected.longitude] : [37.0902, -95.7129]; // Default USA

  return (
    <MapContainer center={center} zoom={5} style={{ height: "100vh", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      {selected && (
        <Marker position={[selected.latitude, selected.longitude]}>
          <Popup>
            <div>
              <p><strong>SSID:</strong> {selected.ssid || selected.bssid}</p>
              <p><strong>Lat:</strong> {selected.latitude.toFixed(6)}</p>
              <p><strong>Lon:</strong> {selected.longitude.toFixed(6)}</p>
              <a
                href={`https://maps.google.com/?q=${selected.latitude},${selected.longitude}`}
                target="_blank"
                rel="noreferrer"
              >
                Open in Google Maps
              </a>
            </div>
          </Popup>
        </Marker>
      )}
      <CenterMap selected={selected} />
    </MapContainer>
  );
};

export default Map;

